import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"zoom-in"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15.8033 15.8033C12.8744 18.7322 8.12563 18.7322 5.1967 15.8033C2.26777 12.8744 2.26777 8.12563 5.1967 5.1967C8.12563 2.26777 12.8744 2.26777 15.8033 5.1967C18.7322 8.12563 18.7322 12.8744 15.8033 15.8033Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8033 15.8033C12.8744 18.7322 8.12563 18.7322 5.1967 15.8033C2.26777 12.8744 2.26777 8.12563 5.1967 5.1967C8.12563 2.26777 12.8744 2.26777 15.8033 5.1967C18.7322 8.12563 18.7322 12.8744 15.8033 15.8033ZM15.8033 15.8033L21.1066 21.1066","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.5 13.5V10.5M10.5 10.5L10.5 7.5M10.5 10.5H7.5M10.5 10.5H13.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ZoomIn = Vue.extend<IconProps>({
  name: 'ZoomInIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'zoom-in',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ZoomIn;
